import { Link } from "react-router-dom";
import { Droplets } from "lucide-react";
import { Reveal } from "@/components/Reveal";

export default function Footer() {
  return (
    <footer data-testid="footer" className="border-t border-white/10">
      <div className="mx-auto max-w-7xl px-6 py-20 lg:px-12">
        <Reveal>
          <p className="font-display text-4xl font-extrabold uppercase leading-none tracking-tighter text-white sm:text-6xl">
            Clean <span className="text-aqua">&</span> Revive
          </p>
          <p className="mt-4 max-w-md text-sm text-zinc-400">
            The sneaker care studio. Hand-cleaned, conditioned and delivered back to your door.
          </p>
        </Reveal>

        <div className="mt-16 grid gap-10 border-t border-white/5 pt-10 sm:grid-cols-3">
          <div>
            <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-zinc-500">Contact</p>
            <a href="mailto:cleanandrevive@gmail.com" data-testid="footer-email" className="mt-3 block text-sm text-zinc-300 transition-colors duration-300 hover:text-aqua">
              cleanandrevive@gmail.com
            </a>
            <a href="tel:+447817234560" data-testid="footer-phone" className="mt-1 block text-sm text-zinc-300 transition-colors duration-300 hover:text-aqua">
              07817 234560
            </a>
          </div>
          <div>
            <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-zinc-500">Hours</p>
            <p className="mt-3 text-sm text-zinc-300">Mon – Sat, 09:00 – 21:00</p>
            <p className="mt-1 text-sm text-zinc-300">Collections 7 days a week</p>
          </div>
          <div>
            <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-zinc-500">Service area</p>
            <p className="mt-3 text-sm text-zinc-300">Free pick-up & delivery within 5 miles.</p>
            <p className="mt-1 text-sm text-zinc-300">Local drop-off points available.</p>
          </div>
        </div>

        <div className="mt-16 flex flex-wrap items-center justify-between gap-6 border-t border-white/5 pt-8">
          <p className="flex items-center gap-2 font-mono text-[10px] uppercase tracking-[0.25em] text-zinc-600">
            <Droplets size={12} className="text-aqua/60" />
            Clean & Revive — 2026
          </p>
          <Link
            to="/about"
            data-testid="footer-about-link"
            className="font-mono text-xs uppercase tracking-[0.2em] text-zinc-400 transition-colors duration-300 hover:text-aqua"
          >
            About & privacy
          </Link>
          <Link to="/book" data-testid="footer-book-button" className="font-mono text-xs uppercase tracking-[0.2em] text-aqua transition-colors duration-300 hover:text-white">
            Book a clean
          </Link>
        </div>
      </div>
    </footer>
  );
}
